var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('export-excel',{staticClass:"btn btn-outline-success",attrs:{"data":_vm.data,"name":_vm.name}},[_c('feather-icon',{attrs:{"size":"21","icon":"DownloadIcon"}}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }